import React from 'react';
import { User, LogOut, Edit2 } from 'lucide-react';
import { Button } from '../../components/Button';
import { Input } from '../../components/Input';
import type { User as FirebaseUser } from 'firebase/auth';

interface SettingsProfileProps {
    user: FirebaseUser | null | undefined;
    displayName: string;
    setDisplayName: (val: string) => void;
    isEditingName: boolean;
    setIsEditingName: (val: boolean) => void;
    onUpdateName: () => void;
    onCancelEditName: () => void;
    onLogout: () => void;
}

export const SettingsProfile: React.FC<SettingsProfileProps> = ({
    user,
    displayName,
    setDisplayName,
    isEditingName,
    setIsEditingName,
    onUpdateName,
    onCancelEditName,
    onLogout
}) => {
    return (
        <div className="p-4 bg-bg-card-alt border-b border-border-default">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <div className="rounded-full bg-primary-500/15 p-2 text-primary-600 dark:text-primary-400">
                        <User size={20} />
                    </div>
                    <div className="flex-1">
                        {user ? (
                            <>
                                {isEditingName ? (
                                    <div className="flex gap-2">
                                        <Input
                                            value={displayName}
                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setDisplayName(e.target.value); }}
                                            className="h-8 py-1 text-sm w-40"
                                            autoFocus
                                        />
                                        <Button size="sm" className="h-8" onClick={onUpdateName}>Save</Button>
                                        <Button variant="ghost" size="sm" className="h-8" onClick={onCancelEditName}>X</Button>
                                    </div>
                                ) : (
                                    <div className="flex items-center gap-2 group">
                                        <p className="text-sm font-bold text-text-heading">
                                            {displayName !== '' ? displayName : (user.email ?? 'User')}
                                        </p>
                                        <button
                                            onClick={() => { setIsEditingName(true); }}
                                            className="text-text-faint hover:text-primary-600 p-1"
                                        >
                                            <Edit2 size={14} />
                                        </button>
                                    </div>
                                )}
                                <p className="text-xs text-text-muted">
                                    {user.isAnonymous ? 'Guest Account' : 'Secured Account'}
                                </p>
                            </>
                        ) : (
                            <>
                                <p className="text-sm font-bold text-text-heading">Guest</p>
                                <p className="text-xs text-text-muted">Not signed in</p>
                            </>
                        )}
                    </div>
                </div>
                {user && !user.isAnonymous && (
                    <Button variant="ghost" size="icon" onClick={onLogout}>
                        <LogOut className="h-5 w-5 text-text-faint" />
                    </Button>
                )}
            </div>
        </div>
    );
};
